// extracted by mini-css-extract-plugin
export default {"Splash":"Splash-module__Splash___DgrPi","exiting":"Splash-module__exiting___1eMgr"};